import globalConfig from '../../utiles/globalConfig';

import * as greenTheme from './greenTheme';
import * as whiteTheme from './whiteTheme';
import * as cloudTheme from './cloudTheme';
import * as omnikadeTheme from './omnikadeTheme';
import * as slfuntapTheme from './slfuntapTheme';
import * as slfuntapVgmTheme from './slfuntapVgmTheme';

let map = {
  'YmxhbmNvem9uZS5jb20=': whiteTheme,
  c2xmdW50YXAuY29t: slfuntapTheme,
  b21uaWthZGUuY29t: omnikadeTheme,
  default: greenTheme
};

export default {
  getByHost(host) {
    if (
      globalConfig.getHrefParam('gameId') == '193' ||
      globalConfig.getHrefParam('game_id') == '193'
    ) {
      return cloudTheme;
    }
    let lang = globalConfig.getLanguages();
    if (host == 'c2xmdW50YXAuY29t' && lang === 'vi-VN') {
      return slfuntapVgmTheme;
    }
    let theme = map[host] || map['default'];
    return theme;
  }
};
